import React, { useContext, useEffect, useState, ChangeEvent } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { ScorecardCreationSectionViewModel } from './Viewmodels/ScorecardCreationViewModel';
import { APIContext } from '../Contexts/APIContext';
import InputLabel from '@mui/material/InputLabel';
import Switch from '@mui/material/Switch';

type Props = {
    open: boolean;
    editId: number;
    templateId: number;
    onClose: (refresh: boolean) => void;
}

export default function AddEditScorecardSectionModal({ open, editId, templateId, onClose }: Props) {
    const { get, post } = useContext(APIContext);
    const [section, setSection] = useState(new ScorecardCreationSectionViewModel(templateId));

    useEffect(() => {
        if (editId > 0 && open) getData();
        else setSection(new ScorecardCreationSectionViewModel(templateId));
    }, [editId, open]);

    const getData = () => {
        get('ScorecardManagement', `GetSectionContent?sectionId=${editId}`, (data) => {
            setSection(data);
        });
    }

    const saveSection = () => {
        post('ScorecardManagement', `AddEditScorecardSection`, section, (data) => {
            onClose(true);
        });
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSection({
            ...section,
            [e.target.name]: e.target.value
        });
    }

    const handleCheckedChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSection({
            ...section,
            [e.target.name]: e.target.checked
        });
    }

    const remove = () => {
        get('ScorecardManagement', `RemoveSection?sectionId=${editId}`, (data) => {
            onClose(true);
        });
    }

    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>{editId > 0 ? "Edit " : "Add "} Scorecard Section</DialogTitle>
            <ValidatorForm onSubmit={saveSection}>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <InputLabel shrink>Section Title</InputLabel>
                            <TextValidator
                                name='sectionTitle'
                                fullWidth
                                value={section.sectionTitle}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                margin="none"
                                validators={['required']}
                                errorMessages={['This field is required']}
                            />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Dependency JSON</InputLabel>
                            <TextValidator
                                name='dependencyJSON'
                                fullWidth
                                value={section.dependencyJSON}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                margin="none"
                            />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Description</InputLabel>
                            <TextValidator
                                name='description'
                                fullWidth
                                value={section.description}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                margin="none"
                            />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Product Type Filter</InputLabel>
                            <TextValidator
                                name='productTypeFilter'
                                fullWidth
                                value={section.productTypeFilter}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                margin="none"
                            />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Page</InputLabel>
                            <TextValidator
                                name='page'
                                fullWidth
                                type='number'
                                value={section.page}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                margin="none"
                                validators={['required']}
                                errorMessages={['This field is required']}
                            />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel shrink>Toggleable</InputLabel>
                            <Switch name='toggleable' onChange={handleCheckedChange} value={section.toggleable} />
                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button onClick={() => onClose(false)}>Cancel</Button>
                        {editId > 0 && <Button color="error" onClick={remove}>Remove</Button>}
                        <Button variant="contained" type="submit">Save</Button>
                    </DialogActions>
                </DialogContent>
            </ValidatorForm>
        </Dialog>
    );
}